const partialTextbox = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsTextbox.hbs');
const partialTextarea = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsTextarea.hbs');
const partialCurrency = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsCurrency.hbs');
const partialDisplayField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDisplayFields.hbs');

const DateTime = require('./dateTime');
const Dropdown = require('./dropdown');
const Label = require('./label');

const general_utils = require('civicsUtils/general_utilities');
const utils = require ('../detail_utilities.js');

define(function (require) {

	var getTextBox = function (ele, readOnlyForm, detailOptions) {
		// If not a textbox, select a different "get"
		if (ele.dataType && ele.dataType.toLowerCase() == "system.datetime") {
			return DateTime.getDateBox(ele, readOnlyForm, detailOptions);
		}
		if (ele.moniker && ele.moniker.length > 0) {
			return Dropdown.getDropdown(ele, readOnlyForm, detailOptions);
		}
		let htmlIndicator = '__html__';
		if(ele.text && ele.text.length > htmlIndicator.length && ele.text.substring(0, htmlIndicator.length).toLowerCase() == htmlIndicator){
			ele.text = ele.text.substring(htmlIndicator.length); //remove the indicator
			ele.isHtml = true;
			return Label.getLabel(ele, readOnlyForm, detailOptions);
		}


		var el;
		var inputType = 'text';

		if(Number(ele.maxLength) > 100){ //page builder doesn't support adding the multiline attribute to text areas in grids, so we do it here "automagically".
			ele.multiLine = true;
		}

		//todo : setting the type to 'number' may break syphon
		if (ele.dataType &&
			 	(ele.dataType.toUpperCase() === 'SYSTEM.INT16' ||
				 ele.dataType.toUpperCase() === 'SYSTEM.INT32' ||
				 ele.dataType.toUpperCase() === 'SYSTEM.INT64' ||
				 ele.dataType.toUpperCase() === 'SYSTEM.DECIMAL' ||
				 ele.dataType.toUpperCase() === 'SYSTEM.SINGLE'
				)){
			inputType = 'number';
		}
		var customData = "";
		// Setting proper data types for numbers
		customData += "data-dataType = \"" + ele.dataType + "\" data-iskeyvalue=\"" + (ele.isKeyValue == true ? "true" : "false")+"\" ";

		var val = ele.value;

		if( inputType == 'number'){
			if ( ele.decimalPlaces ){
				customData += "data-decimalplaces = \"" + ele.decimalPlaces +"\" ";
			}
			if(ele.rangeMaxValid != ele.rangeMinValid){//if the two values are equal, it's bad config. Also, CPQ RS now defaults to 0 for both these values...
				if(ele.rangeMinValid) {
					customData += " data-minVal=\"" +ele.rangeMinValid + "\" ";
				}

				if(ele.rangeMaxValid) {
					customData += " data-maxVal=\"" + ele.rangeMaxValid +"\" ";
				}
			}

			if(ele.value && typeof ele.value == 'string'){
				val = ele.value.replace(/\D/g,'');
			}
		}

		if(_.isEmpty(ele.format)){
			ele.format = "";
		}

		// Formatting display value
		var formattedVal = Handlebars.helpers['global:removeHTML'](ele.value);
		if (ele.format.toLowerCase() == "currency"){
			formattedVal  = Handlebars.helpers['global:formatMoney'](ele.value);
			val = Handlebars.helpers['global:formatMoney'](ele.value, true);//pass in a true editing flag to avoid teh $ being returned

		} else if(ele.format.toLowerCase() == 'decimal'){//Include number formatting for decimal type.
				if(ele.decimalPlaces && parseInt(ele.decimalPlaces) >= 0 ){
					val  = parseFloat(ele.value).toFixed(parseInt(ele.decimalPlaces));
				}else{
					//RC 2018-06-11 - This is for decimal format type that has no decimal places attribute or 0 decimal places attribute.
					val = Handlebars.helpers['global:removeHTML'](ele.value);
				}
		} else if(ele.format.toLowerCase() == 'number' || ele.format.toLowerCase() =='integer' || 
			(ele.dataType &&
				(ele.dataType.toUpperCase() === 'SYSTEM.INT16' ||
				ele.dataType.toUpperCase() === 'SYSTEM.INT32' ||
				ele.dataType.toUpperCase() === 'SYSTEM.INT64' )
			)){
			customData+='step="1" ';
		}

		if(!_.isEmpty(ele.specialType)){
			customData += 'specialType="'+ele.specialType+'" ';
		}

		var classes = 'text-field-container';
		if(ele.multiLine != undefined && ele.multiLine.toString().toUpperCase() === 'TRUE'){
			classes+= ' wider-column';
		}
		if(ele.isVisible === false){
			classes += ' hidden';
		}

		if ( ele.description )
		{
			customData += ' data-tooltip=" ' + general_utils.attributeEscapeString(ele.description) +  '" ';
		}

		var textboxData = {
			id: ele.id,
			qaid: utils.formatId(ele.text, ele.type),
			name: ele.bind ? ele.bind : ele.id,
			classes: classes,
			labelText: ele.text,
			required: ele.isRequired,
			type: inputType,
			disabled: readOnlyForm || ele.isEnabled === false,
			value: readOnlyForm ? formattedVal : val,//if it's a readOnlyForm, show the $ for currency. When readonly, this will be deisplayed in a <p> tag. all other times it will be displayed in an input
			text: readOnlyForm || ele.isEnabled === false ? formattedVal : val,//if it's a readOnlyForm, show the $ for currency. Text should never be displayed in an input.
			showValue: true,
			helperMsg: " ",
			formatType:ele.format.toLowerCase(),
			customAttr: customData
		};

		var maxlength = ele.maxLength && ele.maxLength >0 ? ele.maxLength : 0;
		var minlength = ele.minLength && ele.minLength >0 ? ele.minLength : 0;
		if(maxlength>0){
			textboxData.maxlength = maxlength;
		}
		if(minlength>0){
			textboxData.minlength = minlength;
		}

		if (readOnlyForm) {
			el = partialDisplayField($.extend({}, textboxData));
		}
		else if (ele.multiLine != undefined && ele.multiLine.toString().toUpperCase() === 'TRUE') {
			el = partialTextarea($.extend({}, textboxData));
		}
		else if ( ele.formatType && ele.format.toLowerCase() == "currency") {
			el = partialCurrency($.extend({}, textboxData));
		} else {
			el = partialTextbox($.extend({}, textboxData));
		}

		return el;
	};

	return {
		getTextBox: function(ele, readOnlyForm, detailOptions) {
			return getTextBox(ele, readOnlyForm, detailOptions);
		}
	}
});